import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'

import { HTMLSelect, HTMLSelectProps } from '@blueprintjs/core'

export default (props: HTMLSelectProps) => {
    const { i18n } = useTranslation()
    return <>
        <Helmet htmlAttributes={{ lang: i18n.language }} />

        {!props.hidden && <>
            <HTMLSelect
                {...props}
                options={[
                    { label: "🇯🇵", value: "ja" },
                ]}
                value={i18n.language}
                onChange={(e) => i18n.changeLanguage(e.target.value)}
            />
        </>}
    </>
}